import '@babel/polyfill';

(async () => {
  await import(/* webpackChunkName: "market-main" */ '../pages/market/main');
})();
